// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-product .p-name[data-v-81dbb864]{color:#534f49;font-size:16px;font-weight:400}.h-product:hover .p-name[data-v-81dbb864]{color:#ffa300;font-weight:700}.product-col[data-v-81dbb864]{width:50%}@media(min-width:768px){.product-col[data-v-81dbb864]{width:16.5rem}}.img-wrapper[data-v-81dbb864]{height:6rem}@media(min-width:768px){.img-wrapper[data-v-81dbb864]{height:7.5rem}}", ""]);
// Exports
module.exports = exports;
